import CategoryApi from './CategoryApi'
import LivesApi from './livesApi'
import MovieApi from './MovieApi'
import NewsApi from './NewsApi'
import OtherApi from './OtherApi'
import UserApi from './UserApi'

const api = {
  category: new CategoryApi(),
  movie: new MovieApi(),
  news: new NewsApi(),
  other: new OtherApi(),
  user: new UserApi(),
  lives: new LivesApi()
}

export default {
  ...api,
  install(Vue) {
    Object.keys(api).forEach(key => api[key].install(Vue))
  }
}



// WEBPACK FOOTER //
// ./src/service/api/index.js